import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CharacterVoicesQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.CharacterVoicesFilters>;
}>;


export type CharacterVoicesQuery = { characterVoices: { totalCount: number, success: boolean, edges?: Array<{ node: { id: string, gender?: Types.VideoCharacterGenderEnum | null, provider: Types.VideoCharacterProviderEnum, language: string, name: string, voice_id: string, preview_audio?: string | null, createdBy?: { id: string, firstName?: string | null, lastName?: string | null } | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const CharacterVoicesDocument = /*#__PURE__*/ gql`
    query CharacterVoices($sort: [SortType!], $after: String, $first: Float, $filters: CharacterVoicesFilters) {
  characterVoices(sort: $sort, after: $after, first: $first, filters: $filters) {
    totalCount
    edges {
      node {
        id
        gender
        provider
        language
        name
        voice_id
        preview_audio
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
    totalCount
    success
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

export function useCharacterVoicesQuery(options?: Omit<Urql.UseQueryArgs<CharacterVoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<CharacterVoicesQuery, CharacterVoicesQueryVariables>({ query: CharacterVoicesDocument, ...options });
};